<template>
  <q-card style="width: 700px; max-width: 80vw;">
    <q-form @submit.prevent="addProject">
      <q-card-section>
        <div class="text-h6">Обновить аватар</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        <cropper
            ref="cropperRef"
            class="q-mb-md"
            :src="blob"
            @change="onChange"
            style="min-height: 300px;
		max-height: 500px;"
            :debounce="false"
            :stencil-props="{
			aspectRatio: 1
		}"
        />
        <preview
            :width="120"
            :height="120"
            :image="result.image"
            :coordinates="result.coordinates"
        />
      </q-card-section>

      <q-card-section class="q-pt-none">
        <q-file dense v-model="file" label="Аватар" :rules="[requiredRule]" accept="image/*"/>
      </q-card-section>

      <q-card-actions align="right" class="text-primary">
        <q-btn no-caps flat label="Отмена" color="negative" @click="$emit('cancel')"/>
        <q-btn no-caps flat label="Создать" type="submit"/>
      </q-card-actions>
    </q-form>

  </q-card>
</template>

<script setup lang="ts">
import {requiredRule} from "../util/rules";
import {Cropper, Preview} from 'vue-advanced-cropper'
import {computed, ref, watch} from "vue"
import {useRoute} from "vue-router";
import {useUpdateProjectAvatar} from "../composables/project";

const emits = defineEmits(['add', 'cancel'])

const route = useRoute()

const projectId = computed(() => Number(route.params.projectId))

const cropperRef = ref<InstanceType<typeof Cropper>>();

const file = ref<Blob | null>(null)

const blob = ref<string | null>(null)

watch(file, (newValue, oldValue) => {
  const blobValue = blob.value;
  if (blobValue) {
    URL.revokeObjectURL(blobValue)
  }
  const fileValue = file.value
  if (fileValue) {
    blob.value = URL.createObjectURL(fileValue)
  }
})

const result = ref({
  coordinates: null,
  image: null
})

function onChange(event: { coordinates: any, image: any }) {
  result.value = {
    coordinates: event.coordinates,
    image: event.image
  };
}

function addProject() {
  if (cropperRef.value) {
    const {canvas} = cropperRef.value.getResult();
    canvas?.toBlob(blob => {
      const form = new FormData()
      form.append('avatar', blob);
      useUpdateProjectAvatar(projectId, form)
          .onFetchFinally(() => emits('add'))
    }, 'image/png');
  }

}

</script>

<style scoped>

</style>